/**
 * Configuration class
 */

var _userData = undefined;
var _currentRegionId = undefined;

// The config param only work for server side.
var ApplicationContext = function () {
    // used to store user grid/list view style to keep it consitant user experience.
    this.styleStore = {};
};

ApplicationContext.prototype.setup = function(config) {
    console.log(`ApplicationContext:`)
    console.log(JSON.stringify(config))
    this.assetUrlPrefix = config.assetUrlPrefix;
    this.contentServer = config.contentServer;
    this.componentEditor = config.componentEditor;
    this.symbolEditor = config.symbolEditor;
    this.footprintEditor = config.footprintEditor;
    this.packageEditor = config.packageEditor;
    this.packageLibrary = config.packageLibrary;
    this.adskAccountUrl = config.adskAccountUrl;
    this.defaultUserAvatar = config.defaultUserAvatar;
    this.gaAccount = config.gaAccount;
    this.tealiumURL = config.tealiumURL;
    this.homeRegion = config.homeRegion;
    this.configuredRegions = config.regions;

    this.env = config.env;
};

ApplicationContext.prototype.getHomeRegion = function() {
    return this.homeRegion;
};

// The region the user is currently operating in (the region of the selected
// folder). Defaults to the home region until a folder in another region is opened.
ApplicationContext.prototype.setCurrentRegion = function(regionId) {
    _currentRegionId = regionId;
};

ApplicationContext.prototype.getCurrentRegion = function() {
    return _currentRegionId || this.homeRegion;
};

ApplicationContext.prototype.setUserData = function(data) {
    _userData = data;
};

ApplicationContext.prototype.getUserData = function() {
    return _userData;
};

// Whether regionalization (R13N) is enabled for the current user. Driven by the
// server-side SDM feature flag surfaced on the user data (userUsageInfoFromSession).
// Defaults to false until user data is loaded or if the flag is absent.
ApplicationContext.prototype.isR13Enabled = function() {
    return !!(_userData?.r13nExperienceEnabled);
};

ApplicationContext.prototype.getDefaultUserAvatar = function() {
    return this.defaultUserAvatar;
};

ApplicationContext.prototype.usContentUrl = function() {
    return this.contentServer.server + "/" + this.contentServer.tenant;
};

ApplicationContext.prototype.detDataModelVersion = function() {
    return this.contentServer.dataModelVersion;
};

ApplicationContext.prototype.getComponentEditor = function() {
    return this.componentEditor;
};

ApplicationContext.prototype.getSymbolEditor = function() {
    return this.symbolEditor;
};

ApplicationContext.prototype.getFootprintEditor = function() {
    return this.footprintEditor;
};

ApplicationContext.prototype.getPackageEditor = function() {
    return this.packageEditor;
};

ApplicationContext.prototype.getPackageLibrary = function() {
    return this.packageLibrary;
};

ApplicationContext.prototype.getAdskAccountUrl = function() {
    return this.adskAccountUrl;
};

ApplicationContext.prototype.onLibraryChange = function(count) {
    if(isNaN(count)) {
        throw "Input is wrong.";
    } else if(_userData && _userData.usage) {
        _userData.usage.library = parseInt(_userData.usage.library) + count;
    }
}

module.exports = new ApplicationContext();
